/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearStorage, getItem } from "../../../utils/localStorage";
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";

function Nav() {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [userName, setFullname] = useState("");
  const [userRole, setRole] = useState("");

  const HandleLogOut = async () => {
    await clearStorage();
    navigate("/");
  };
  const getCurrentUser = async () => {
    try {
      const currentUserValue = await getItem("LANDLORDUSER");
      if (currentUserValue) {
        const currentUser = JSON.parse(currentUserValue);
        const fullName = currentUser.user.fullName;
        const role = currentUser.user.type;
        setFullname(fullName);
        setRole(role);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, []);
  return (
    <nav className="pc-sidebar">
      <div className="navbar-wrapper">
        <div className="m-header">
          <Link to={"/resident/"} className="b-brand text-primary">
            <img
              src="/assets/images/PayServeLogoFinal.png"
              className="img-fluid logo-lg"
              alt="logo"
              style={{ width: 180 }}
            />
            <span className="badge bg-light-success rounded-pill ms-2 theme-version">
              v1.0
            </span>
          </Link>
        </div>
        <div className="navbar-content" style={{ overflowY: "scroll" }}>
          <div className="card pc-user-card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/user/avatar-1.jpg"
                    alt="user-image"
                    className="user-avtar wid-45 rounded-circle"
                  />
                </div>
                <div className="flex-grow-1 ms-3 me-2">
                  <h6 className="mb-0">{userName}</h6>
                  <small>Landlord</small>
                </div>
                <Link
                  className="btn btn-icon btn-link-secondary avtar"
                  data-bs-toggle="collapse"
                  to="#pc_sidebar_userlink"
                >
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-sort-outline" />
                  </svg>
                </Link>
              </div>
              <div className="collapse pc-user-links" id="pc_sidebar_userlink">
                <div className="pt-3">
                  {/* <Link to={"/resident/settings"}>
                                        <i className="ti ti-settings" />
                                        <span>Settings</span>
                                    </Link> */}

                  <Link
                    to={"#!"}
                    onClick={() => {
                      HandleLogOut();
                    }}
                  >
                    <i className="ti ti-power" />
                    <span>Logout</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <ul className="pc-navbar mb-5">
            <li
              className={`pc-item ${currentPath === "/landlord/facilities"
                  ? "active"
                  : "" || currentPath === "/landlord/facilities"
                    ? "active"
                    : ""
                }`}
            >
              <Link to={"/landlord/facilities"} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-logout" />
                  </svg>
                </span>

                <span className="pc-mtext">Home Page</span>
              </Link>
            </li>

            <li
              className={`pc-item ${currentPath === "/landlord_portal"
                  ? "active"
                  : "" || currentPath === "/landlord_portal"
                    ? "active"
                    : ""
                }`}
            >
              <Link to={"/landlord_portal"} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-home" />
                  </svg>
                </span>

                <span className="pc-mtext">Dashboard</span>
              </Link>
            </li>





            <li className="pc-item pc-caption">
              <label>Key Metrics</label>
              <svg className="pc-icon">
                <use xlinkHref="#custom-layer" />
              </svg>
            </li>

            <li className={`pc-item ${currentPath === '/portal/metrics/revenue_reports' ? 'active' : ''}`}>
              <Link to={'/portal/metrics/revenue_reports'} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-keyboard" />
                  </svg>
                </span>
                <span className="pc-mtext">Revenue Reports</span>
              </Link>
            </li>

            <li className={`pc-item ${currentPath === '/portal/metrics/occupancy_reports' || currentPath === '/portal/metrics/occupancy_reports' ? 'active' : ''}`}>
              <Link to={'/portal/metrics/occupancy_reports'} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-user-add" />
                  </svg>
                </span>
                <span className="pc-mtext">Occupancy Reports</span>
              </Link>
            </li>

            <li className={`pc-item ${currentPath === '/portal/metrics/expense_reports' || currentPath === '/portal/metrics/expense_reports' ? 'active' : ''}`}>
              <Link to={'/portal/metrics/expense_reports'} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-cpu-charge" />
                  </svg>
                </span>
                <span className="pc-mtext">Expense Reports</span>
              </Link>
            </li>




            <li className="pc-item pc-caption">
              <label>Task Approvals</label>
              <svg className="pc-icon">
                <use xlinkHref="#custom-layer" />
              </svg>
            </li>

            {/* <li className={`pc-item ${currentPath === '/portal/approvals/lease_approvals' ? 'active' : ''}`}>
              <Link to={'/portal/approvals/lease_approvals'} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-keyboard" />
                  </svg>
                </span>
                <span className="pc-mtext">Lease Approvals</span>
              </Link>
            </li> */}

            <li className={`pc-item ${currentPath === '/portal/approvals/maintenance_appprovals' || currentPath === '/portal/approvals/maintenance_appprovals' ? 'active' : ''}`}>
              <Link to={'/portal/approvals/maintenance_appprovals'} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-user-add" />
                  </svg>
                </span>
                <span className="pc-mtext">Maintenance Approvals</span>
              </Link>
            </li>

            {/* <li className={`pc-item ${currentPath === '/portal/approvals/expense_appprovals' || currentPath === '/portal/approvals/expense_appprovals' ? 'active' : ''}`}>
              <Link to={'/portal/approvals/expense_appprovals'} className="pc-link">
                <span className="pc-micon">
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-cpu-charge" />
                  </svg>
                </span>
                <span className="pc-mtext">Expense Approvals</span>
              </Link>
            </li> */}



          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Nav;
